<template>
    <mu-switch label="开关" />
</template>
<script>
export default {
    name: 'switch'
}
</script>



// WEBPACK FOOTER //
// switch.vue?39be045c